import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { observer } from 'mobx-react-lite'
import CheckBox from '../../Components/CheckBox/CheckBox'
import { FaPlusSquare } from 'react-icons/fa'
import { FiEdit } from 'react-icons/fi'
import { MdDeleteOutline, MdOutlineSaveAlt } from 'react-icons/md'
import http from '../../Service/http'
import { toast } from 'react-toastify'
import { accept, OknoRoleType } from '../../store/accept'
import SearchRole from '../../block/ReactSearchRole'
import { getOknoStudentRole } from '../../Service/accept'
import { FcCancel } from 'react-icons/fc'
import ConfirmModal from './../../Components/Modal/ConfirmModal'

export const AcceptStudent = observer(function () {
	const { t } = useTranslation()
	const notify = (title: string) => toast.success(title)
	const [idTeacher, setIdTeacher] = useState<number>(0)
	const [addNew, setAddNew] = useState<boolean>(false)
	const [form, setForm] = useState<OknoRoleType>({
		Buhgalteriy: false,
		KjMTB: false,
		biblioteka: false,
		ckb: false,
		dekanat: false,
		id_role_okno: 0,
		obshejitie: false,
		pole1: false,
		pole2: false,
		pole3: false,
		t_fio: ''
	})

	const [delModal, setDelModal] = useState<{
		modal: boolean
		id_docs: number
	}>({
		modal: false,
		id_docs: 0
	})

	const [disbles, setDsbles] = useState<number>(0)

	const getAllTeachers = async () => {
		const data = await getOknoStudentRole()
		accept.newOknoRoles(data)
	}
	useEffect(() => {
		getAllTeachers()
		const app = document.querySelector('.LayoutPage')
		if (app) {
			app.addEventListener('click', (e: any) => {
				if (e.target) {
					const searchWrap = e.target.closest('.ContentsWrapper')
					if (!searchWrap) {
						setDsbles(0)
					}
				}
			})
		}
	}, [])
	const tdCenter = { display: 'flex', justifyContent: 'center', width: '100%' }

	return (
		<>
			<ConfirmModal
				setIsOpen={() => {
					setDelModal({
						modal: false,
						id_docs: 0
					})
				}}
				title={'Удалить'}
				isOpen={delModal.modal}
				hundleTrue={async () => {
					if (delModal.id_docs) {
						const res = await http.delete('/okno/student?id=' + delModal.id_docs)
						if (res.data.result) {
							getAllTeachers()
							notify('Успешно удалено!')
							setDelModal({
								modal: false,
								id_docs: 0
							})
						}
					}
				}}
			/>
			<div className='TableWrapper'>
				<table className='accept_table'>
					<thead>
						<tr>
							<th style={{ width: '5%' }}>№</th>
							<th style={{ width: '35%', textAlign: 'left' }}>{t('st:table.fio')}</th>
							<th style={{ width: '5%' }}>{t('st:accept.titles.educDep')}</th>
							<th style={{ width: '5%' }}>{t('st:accept.titles.specOKO')}</th>
							<th style={{ width: '5%' }}>{t('st:accept.titles.kafedra')}</th>
							<th style={{ width: '5%' }}>{t('st:accept.titles.hostel')}</th>
							<th style={{ width: '5%' }}>{t('st:accept.titles.bib')}</th>
							<th style={{ width: '5%' }}>{t('st:accept.titles.finDep')}</th>
							<th style={{ width: '5%' }}>{t('st:accept.titles.hr')}</th>
							<th style={{ width: '5%' }}>{t('st:accept.titles.military')}</th>
							<th style={{ width: '5%' }}>{t('st:accept.titles.secretaryGAK')}</th>
							<th style={{ width: '5%' }}>
								<FaPlusSquare
									style={{ fontSize: 18 }}
									onClick={() => {
										setAddNew(!addNew)
										setDsbles(0)
									}}
								/>
							</th>
						</tr>
					</thead>
					<tbody>
						{addNew ? (
							<tr style={{ backgroundColor: 'rgb(160 202 223)', height: '52' }}>
								<td>{0}</td>
								<td style={{ textAlign: 'left' }}>
									<SearchRole
										style={{ borderRadius: '6px' }}
										changeIdStud={(param: number) => {
											setIdTeacher(param)
										}}
									/>
								</td>
								<td>
									<CheckBox
										styles={tdCenter}
										onchange={(e: any) => {
											setForm((state: any) => {
												return { ...state, ckb: e }
											})
										}}
										checked={form.ckb}
										active={true}
										dsbl={false}
										item={form}
									/>
								</td>
								<td>
									<CheckBox
										styles={tdCenter}
										onchange={(e: any) => {
											setForm((state: any) => {
												return { ...state, dekanat: e }
											})
										}}
										checked={form.dekanat}
										active={true}
										dsbl={false}
										item={form}
									/>
								</td>
								<td>
									<CheckBox
										styles={tdCenter}
										onchange={(e: any) => {
											setForm((state: any) => {
												return { ...state, KjMTB: e }
											})
										}}
										checked={form.KjMTB}
										active={true}
										dsbl={false}
										item={form}
									/>
								</td>
								<td>
									<CheckBox
										styles={tdCenter}
										onchange={(e: any) => {
											setForm((state: any) => {
												return { ...state, obshejitie: e }
											})
										}}
										checked={form.obshejitie}
										active={true}
										dsbl={false}
										item={form}
									/>
								</td>
								<td>
									<CheckBox
										styles={tdCenter}
										onchange={(e: any) => {
											setForm((state: any) => {
												return { ...state, biblioteka: e }
											})
										}}
										checked={form.biblioteka}
										active={true}
										dsbl={false}
										item={form}
									/>
								</td>
								<td>
									<CheckBox
										styles={tdCenter}
										onchange={(e: any) => {
											setForm((state: any) => {
												return { ...state, Buhgalteriy: e }
											})
										}}
										checked={form.Buhgalteriy}
										active={true}
										dsbl={false}
										item={form}
									/>
								</td>
								<td>
									<CheckBox
										styles={tdCenter}
										onchange={(e: any) => {
											setForm((state: any) => {
												return { ...state, pole1: e }
											})
										}}
										checked={form.pole1}
										active={true}
										dsbl={false}
										item={form}
									/>
								</td>
								<td>
									<CheckBox
										styles={tdCenter}
										onchange={(e: any) => {
											setForm((state: any) => {
												return { ...state, pole2: e }
											})
										}}
										checked={form.pole2}
										active={true}
										dsbl={false}
										item={form}
									/>
								</td>
								<td>
									<CheckBox
										styles={tdCenter}
										onchange={(e: any) => {
											setForm((state: any) => {
												return { ...state, pole3: e }
											})
										}}
										checked={form.pole3}
										active={true}
										dsbl={false}
										item={form}
									/>
								</td>
								<td>
									<div className='edit'>
										{
											<MdOutlineSaveAlt
												title={t('st:button.save')}
												onClick={async () => {
													const res = await http.post('/okno/student', { ...form, id_teacher: idTeacher })
													setAddNew(!addNew)
													if (res.data.result) {
														const data = await getOknoStudentRole()
														accept.newOknoRoles(data)
														notify(t('st:other.saved'))
													}
												}}
											/>
										}
									</div>
								</td>
							</tr>
						) : (
							''
						)}
						{accept.oknoRole.map((item: any, index: number) => {
							let dsbl = true
							if (disbles == item.id_role_okno) {
								return (
									<tr key={index} style={{ backgroundColor: 'rgb(160 202 223)', height: dsbl ? '' : '52' }}>
										<td>{index + 1}</td>
										<td style={{ textAlign: 'left' }}>{item.t_fio}</td>
										<td>
											<CheckBox
												styles={tdCenter}
												onchange={(e: any) => {
													setForm((state: any) => {
														return { ...state, ckb: e }
													})
												}}
												checked={form.ckb}
												active={true}
												dsbl={false}
												item={form}
											/>
										</td>
										<td>
											<CheckBox
												styles={tdCenter}
												onchange={(e: any) => {
													setForm((state: any) => {
														return { ...state, dekanat: e }
													})
												}}
												checked={form.dekanat}
												active={true}
												dsbl={false}
												item={form}
											/>
										</td>
										<td>
											<CheckBox
												styles={tdCenter}
												onchange={(e: any) => {
													setForm((state: any) => {
														return { ...state, KjMTB: e }
													})
												}}
												checked={form.KjMTB}
												active={true}
												dsbl={false}
												item={form}
											/>
										</td>
										<td>
											<CheckBox
												styles={tdCenter}
												onchange={(e: any) => {
													setForm((state: any) => {
														return { ...state, obshejitie: e }
													})
												}}
												checked={form.obshejitie}
												active={true}
												dsbl={false}
												item={form}
											/>
										</td>
										<td>
											<CheckBox
												styles={tdCenter}
												onchange={(e: any) => {
													setForm((state: any) => {
														return { ...state, biblioteka: e }
													})
												}}
												checked={form.biblioteka}
												active={true}
												dsbl={false}
												item={form}
											/>
										</td>
										<td>
											<CheckBox
												styles={tdCenter}
												onchange={(e: any) => {
													setForm((state: any) => {
														return { ...state, Buhgalteriy: e }
													})
												}}
												checked={form.Buhgalteriy}
												active={true}
												dsbl={false}
												item={form}
											/>
										</td>
										<td>
											<CheckBox
												styles={tdCenter}
												onchange={(e: any) => {
													setForm((state: any) => {
														return { ...state, pole1: e }
													})
												}}
												checked={form.pole1}
												active={true}
												dsbl={false}
												item={form}
											/>
										</td>
										<td>
											<CheckBox
												styles={tdCenter}
												onchange={(e: any) => {
													setForm((state: any) => {
														return { ...state, pole2: e }
													})
												}}
												checked={form.pole2}
												active={true}
												dsbl={false}
												item={form}
											/>
										</td>
										<td>
											<CheckBox
												styles={tdCenter}
												onchange={(e: any) => {
													setForm((state: any) => {
														return { ...state, pole3: e }
													})
												}}
												checked={form.pole3}
												active={true}
												dsbl={false}
												item={form}
											/>
										</td>
										<td>
											<div className='edit'>
												{
													<MdOutlineSaveAlt
														title={t('st:button.save')}
														onClick={async () => {
															const res = await http.put('/okno/student', form)
															if (res.data.result) {
																const data = await getOknoStudentRole()
																accept.newOknoRoles(data)
																notify(t('st:other.saved'))
																setDsbles(0)
															}
														}}
													/>
												}
												<FcCancel
													onClick={() => {
														setDsbles(0)
													}}
												/>
											</div>
										</td>
									</tr>
								)
							}
							return (
								<tr
									key={index}
									style={{ backgroundColor: dsbl ? '' : 'rgb(160 202 223)', height: dsbl ? '' : '52' }}
									onClick={() => {
										setDsbles(0)
										setAddNew(false)
									}}
								>
									<td>{index + 1}</td>
									<td style={{ textAlign: 'left' }}>{item.t_fio}</td>
									<td>
										<CheckBox
											styles={tdCenter}
											onchange={() => {}}
											checked={item.ckb}
											active={true}
											dsbl={dsbl}
											item={''}
										/>
									</td>
									<td>
										<CheckBox
											styles={tdCenter}
											onchange={() => {}}
											checked={item.dekanat}
											active={true}
											dsbl={dsbl}
											item={''}
										/>
									</td>
									<td>
										<CheckBox
											styles={tdCenter}
											onchange={() => {}}
											checked={item.KjMTB}
											active={true}
											dsbl={dsbl}
											item={''}
										/>
									</td>
									<td>
										<CheckBox
											styles={tdCenter}
											onchange={() => {}}
											checked={item.obshejitie}
											active={true}
											dsbl={dsbl}
											item={''}
										/>
									</td>
									<td>
										<CheckBox
											styles={tdCenter}
											onchange={() => {}}
											checked={item.biblioteka}
											active={true}
											dsbl={dsbl}
											item={''}
										/>
									</td>
									<td>
										<CheckBox
											styles={tdCenter}
											onchange={() => {}}
											checked={item.Buhgalteriy}
											active={true}
											dsbl={dsbl}
											item={''}
										/>
									</td>
									<td>
										<CheckBox
											styles={tdCenter}
											onchange={() => {}}
											checked={item.pole1}
											active={true}
											dsbl={dsbl}
											item={''}
										/>
									</td>
									<td>
										<CheckBox
											styles={tdCenter}
											onchange={() => {}}
											checked={item.pole2}
											active={true}
											dsbl={dsbl}
											item={''}
										/>
									</td>
									<td>
										<CheckBox
											styles={tdCenter}
											onchange={() => {}}
											checked={item.pole3}
											active={true}
											dsbl={dsbl}
											item={''}
										/>
									</td>
									<td>
										<div className='edit'>
											{
												<FiEdit
													onClick={(e: any) => {
														e.stopPropagation()
														setDsbles(item.id_role_okno)
														setForm(item)
														setAddNew(false)
													}}
												/>
											}
											<MdDeleteOutline
												style={{ zIndex: 1222 }}
												onClick={() => {
													setDelModal({
														modal: true,
														id_docs: item.id_role_okno
													})
												}}
											/>
										</div>
									</td>
								</tr>
							)
						})}
					</tbody>
				</table>
			</div>
		</>
	)
})
